import React from 'react';
import DAMAGE from './DAMAGE';

const InvJwDamage = () => {
  return <DAMAGE />;
};

export default InvJwDamage;
